import React from 'react';
import T from 'prop-types';

import Tooltip from '../../../../../Tooltip';
import Button from '../../../../../Buttons/Button';
import SimpleCard from '../../../../../Card/SimpleCard';
import ThresholdBadge from '../../../../../ThresholdBadge';

import { format, formatQuarterYear } from '../../../../../../utils/date';

const KpiForecastsQV = ({ company, forecasts }) => (
  <SimpleCard
    className="kpi-forecasts-qv"
    headerLeft={
      <>
        <div className="company-performance__forecasts-head-icon">
          <i className="hicon-chart-dot" />
        </div>
        <h4 className="h4">KPI Forecasts</h4>
        <div className="forecasts-header-heading__stats">
          {formatQuarterYear(forecasts[0]?.forecasts.forecast_period)}
          <span className="mx-xxs">·</span>
          {format(forecasts[0]?.forecasts.forecast_published_at, 'MMMM DD, YYYY')}
        </div>
      </>
    }
    headerRight={
      <Button
        variant="secondary"
        shape="square"
        href={`/companies/${company.ref_no}#kpi-forecasts`}
      >
        <i className="hicon-angle-right-new" />
      </Button>
    }
  >
    <div className="kpi-forecasts-qv__trow">
      <div className="kpi-forecasts-qv__thcell">KPI</div>
      <div className="kpi-forecasts-qv__thcell text-right">Forecast</div>
      <div className="kpi-forecasts-qv__thcell text-right">Delta to Cons</div>
    </div>
    {forecasts.map((item) => (
      <div key={item.kpi_id} className="kpi-forecasts-qv__trow">
        <Tooltip content={item.kpi_name}>
          <div className="kpi-forecasts-qv__tdcell text-truncate">{item.kpi_name}</div>
        </Tooltip>
        <div className="kpi-forecasts-qv__tdcell">
          <ThresholdBadge
            value={item.forecasts.forecast_yoy || '-'}
            valueUnit={
              <span>
                % <span className="value-caption">YoY</span>
              </span>
            }
          />
        </div>
        <div className="kpi-forecasts-qv__tdcell">
          <ThresholdBadge value={item.forecasts.delta} />
        </div>
      </div>
    ))}
  </SimpleCard>
);

KpiForecastsQV.propTypes = {
  company: T.shape({
    ref_no: T.oneOfType([T.string, T.number]),
  }).isRequired,
  forecasts: T.array.isRequired,
};

export default KpiForecastsQV;
